import {
  Dialog, IconButton,
  makeStyles
} from "@material-ui/core";
import { CloseOutlined } from "@material-ui/icons";
import ColorButton from "components/common/ColorButton";
import PersonalSignature from "components/user/PersonalSignature";
import { useState } from "react";

const useStyles = makeStyles(() => ({
  warpDialog: {
    padding: "30px",
    minWidth: "350px",
    minHeight: "500px",
  },
}));

function PersonalSignatureDialogButton() {
  const classes = useStyles();
  const [isOpenDialog, setIsOpenDialog] = useState(false);

  const handleOpen = () => {
    setIsOpenDialog(true)
  }
  const handleClose = () => {
    setIsOpenDialog(false)
  }

  return (
    <>
      <Dialog
        onClose={handleClose}
        aria-labelledby="simple-dialog-title"
        open={isOpenDialog}
        fullWidth={true}
        maxWidth="lg"
        className={classes.warpDialog}>
        <>
          <div style={{ position: 'absolute', top: 16, right: 16 }}>
            <IconButton onClick={handleClose}>
              <CloseOutlined />
            </IconButton>
          </div>
          <PersonalSignature />
        </>
      </Dialog>
      <ColorButton style={{ height: 40, width: 125, marginLeft: 20 }} variant="contained" color="primary" onClick={handleOpen}>
        Signature
      </ColorButton>
    </>
  )
}

export default PersonalSignatureDialogButton